import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';
export var Footer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-top: #ebedf0 solid ", "px;\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])), gridSize() / 4, gridSize() / 2, gridSize() / 2);